import IOption from "common/models/IOption";
import { IWidgetProps } from "decorator-form";
import React from "react";
import ButtonSelect from "./common/ButtonSelect";

/**
 * @description input for selecting object-fit css property for images
 * @author chills
 */

export enum ObjectFit {
	COVER = "cover",
	CONTAIN = "contain",
	NONE = "none"
}

const options: IOption[] = [
	{label: "Cover", value: ObjectFit.COVER},
	{label: "Contain", value: ObjectFit.CONTAIN},
	{label: "None", value: ObjectFit.NONE}
];

const ObjectFitWidget: React.SFC<IWidgetProps<string>> = (props) => {
	return <ButtonSelect {...props} options={options} />;
};

export default ObjectFitWidget;



// WEBPACK FOOTER //
// ./src/common/form/widgets/ObjectFitWidget.tsx